import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../DomainTypes';
import DateCyclesVM from './DateCyclesVM';
import InterestRateCalculationTypesVM from './InterestRateCalculationTypesVM'
import InterestRateTypesVM from './InterestRateTypesVM';

@NeoModel
export default class InvestmentSetupVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private investmentSetupApiClient = AppService.get(Types.Domain.ApiClients.InvestmentSetup)) {

        super(taskRunner);

        this.dateCyclesVM = this.registerViewModel(DateCyclesVM);
        this.interestRateCalculationTypesVM = this.registerViewModel(InterestRateCalculationTypesVM);
        this.interestRateTypesVM = this.registerViewModel(InterestRateTypesVM);
    }

    public async initialise() {

    }

    public dateCyclesVM: DateCyclesVM;
    public interestRateCalculationTypesVM: InterestRateCalculationTypesVM;
    public interestRateTypesVM: InterestRateTypesVM;
}